import axios from 'axios';
import { API_BASE_URL } from '../config';
import { authHeaders, asErr } from '../utils/apiHelpers';

// [{ id, name }]
export async function fetchJobs() {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/lookup/employment/jobs`, {
      headers: authHeaders({ 'Cache-Control': 'no-store' }),
    });
    return res.data;
  } catch (err) {
    throw asErr('Failed to fetch jobs', err);
  }
}

// [{ code, name_ar, name_en }]
export async function fetchStaffRelationTypes() {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/lookup/employment/staff-relation-types`, {
      headers: authHeaders({ 'Cache-Control': 'no-store' }),
    });
    return res.data;
  } catch (err) {
    throw asErr('Failed to fetch staff relation types', err);
  }
}

// convenience: return maps ready for display
export async function fetchEmploymentLookupMaps(i18nLang = 'ar') {
  const [jobs, rels] = await Promise.all([fetchJobs(), fetchStaffRelationTypes()]);
  const jobNameById = {};
  for (const j of jobs || []) jobNameById[j.id] = j.name;

  const relationNameByCode = {};
  const preferAr = String(i18nLang).startsWith('ar');
  for (const r of rels || []) {
    relationNameByCode[r.code] = preferAr ? (r.name_ar || r.name_en || r.code)
                                          : (r.name_en || r.name_ar || r.code);
  }
  return { jobNameById, relationNameByCode };
}
